let qsProduct = null;
let qsCurrentVariant = null;

const qsModal = document.querySelector('#quick-shop');
const qsImage = document.querySelector('#qs-image');
const qsTitle = document.querySelector('#qs-title');
const qsDescription = document.querySelector('#qs-description');
const qsPrice = document.querySelector('#qs-price');
const qsVariantName = document.querySelector('#qs-variant-name');
const qsColors = document.querySelector('#qs-colors');
const qsSizes = document.querySelector('#qs-sizes');
const qsLengths = document.querySelector('#qs-lengths');
const qsVariantId = document.querySelector('#qs-variant-id');
const qsImageWrap = document.querySelector('.qs-image');
const qsReview = document.querySelector('#qs-review');

async function openQuickShop(handle, selectedColor) {
  const res = await fetch(`/products/${handle}.js`);
  qsProduct = await res.json();

  qsTitle.textContent = qsProduct.title;
  qsDescription.textContent = stripHTML(qsProduct.description);
  buildColors(selectedColor);
  buildSizes();
  buildLengths();
  qsModal.classList.add('active');

  updateVariant();
}

function copyReviewBadge(btn) {
  const card = btn.closest('.women-product-card'); // adjust selector if needed
  const badge = card.querySelector('.jdgm-preview-badge');

  if (!badge) return;

  const clone = badge.cloneNode(true);

  const qsReview = document.querySelector('#qs-review');
  qsReview.innerHTML = '';
  qsReview.appendChild(clone);
}

function stripHTML(html) {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || '';
}

function closeQuickShop() {
  qsModal.classList.remove('active');
  qsImage.src = '';
  qsTitle.textContent = '';
  qsPrice.textContent = '';
  qsDescription.textContent = '';
  qsVariantName.textContent = '';
  qsColors.innerHTML = '';
  qsSizes.innerHTML = '';
  qsVariantId.value = '';
  qsProduct = null;
  qsCurrentVariant = null;
}

function buildColors(selectedColor) {
  qsColors.innerHTML = '';

  const colorOption = qsProduct.options.find((o) => o.name.toLowerCase().includes('color'));

  if (!colorOption) return;

  colorOption.values.forEach((color) => {
    const btn = document.createElement('button');
    btn.className = 'qs-color color-swatch qs-color-swatch';
    btn.dataset.color = color;
    btn.title = color;

    /* find swatch in product card */
    const swatch = document.querySelector(`.color-swatch[data-color="${color}"]`);

    const swatchImg = swatch?.querySelector('img');

    if (swatchImg) {
      btn.style.backgroundImage = `url(${swatchImg.src})`;
      btn.style.backgroundSize = 'cover';
      btn.style.backgroundPosition = 'center';
    } else {
      btn.style.background = color;
    }

    if (color === selectedColor) {
      btn.classList.add('active');
    }

    qsColors.appendChild(btn);
  });
}

function buildSizes() {
  qsSizes.innerHTML = '';

  const sizeOption = qsProduct.options.find((o) => o.name.toLowerCase().includes('size'));
  if (!sizeOption) return;

  sizeOption.values.forEach((size, index) => {
    const btn = document.createElement('button');

    btn.className = 'qs-size';
    btn.dataset.size = size;
    btn.textContent = size;

    if (index === 0) btn.classList.add('active');

    qsSizes.appendChild(btn);
  });

  buildLengths(); // ✅ IMPORTANT
}

function buildLengths() {
  qsLengths.innerHTML = '';

  const activeColor = document.querySelector('.qs-color.active')?.dataset.color;
  const activeSize = document.querySelector('.qs-size.active')?.dataset.size;

  const lengthOption = qsProduct.options.find(
    (o) => o.name.toLowerCase().includes('length') || o.name.toLowerCase().includes('inseam'),
  );

  const qsLengthLabel = document.querySelector('.length-label');

  if (!lengthOption) {
    if (qsLengthLabel) qsLengthLabel.style.display = 'none';
    return;
  } else {
    if (qsLengthLabel) qsLengthLabel.style.display = '';
  }

  if (!lengthOption) return;

  let firstAvailableBtn = null;

  lengthOption.values.forEach((length) => {
    const btn = document.createElement('button');

    btn.className = 'qs-length';
    btn.dataset.length = length;
    btn.textContent = length;
    const isAvailable = qsProduct.variants.some(
      (v) =>
        v.available && v.options.includes(activeColor) && v.options.includes(activeSize) && v.options.includes(length),
    );

    if (!isAvailable) {
      btn.classList.add('is-disabled');
      btn.disabled = true;
    } else if (!firstAvailableBtn) {
      firstAvailableBtn = btn;
    }

    qsLengths.appendChild(btn);
  });

  if (firstAvailableBtn) {
    firstAvailableBtn.classList.add('active');
  }
}

function updateVariant() {
  const activeColor = document.querySelector('.qs-color.active')?.dataset.color;
  const activeSize = document.querySelector('.qs-size.active')?.dataset.size;
  const activeLength = document.querySelector('.qs-length.active')?.dataset.length;

  qsVariantName.textContent = activeColor;

  if (!activeColor || !activeSize) return;

  const variant = qsProduct.variants.find((v) => {
    const matchColor = v.options.includes(activeColor);
    const matchSize = v.options.includes(activeSize);
    const matchLength = activeLength ? v.options.includes(activeLength) : true;

    return matchColor && matchSize && matchLength;
  });

  const addBtn = document.querySelector('.qs-add');

  if (!variant || !variant.available) {
    qsVariantId.value = '';
    addBtn.disabled = true;
    return;
  }

  qsCurrentVariant = variant;
  qsVariantId.value = variant.id;

  addBtn.disabled = false;

  qsPrice.textContent = '$' + Math.round(variant.price / 100);

  if (variant.featured_image && qsProduct.images) {
    const startIndex = variant.featured_image.position - 1;
    const secondImage = qsProduct.images[startIndex + 1] || qsProduct.images[startIndex];

    qsImageWrap.classList.remove('loaded');

    qsImage.onload = () => {
      qsImageWrap.classList.add('loaded');
    };

    qsImage.src = secondImage + '&width=900';
  }
}

document.addEventListener('click', async function (e) {
  const quickBtn = e.target.closest('.quick-shop-btn');

  if (quickBtn) {
    const handle = quickBtn.dataset.productHandle;
    const color = quickBtn.dataset.selectedColor;

    /* start loader */
    quickBtn.classList.add('is-loading');
    quickBtn.disabled = true;

    try {
      await openQuickShop(handle, color);
      copyReviewBadge(quickBtn);
    } catch (err) {
      console.error(err);
    } finally {
      /* stop loader */
      quickBtn.classList.remove('is-loading');
      quickBtn.disabled = false;
    }

    return; // stop further click processing
  }

  if (
    e.target.closest('.quick-shop-overlay') ||
    e.target.closest('.quick-shop-close') ||
    e.target.closest('.qs-keep')
  ) {
    closeQuickShop();
  }

  const colorBtn = e.target.closest('.qs-color');
  if (colorBtn) {
    document.querySelectorAll('.qs-color').forEach((b) => b.classList.remove('active'));
    colorBtn.classList.add('active');

    buildLengths(); // ✅
    updateVariant();
  }

  const sizeBtn = e.target.closest('.qs-size');
  if (sizeBtn) {
    document.querySelectorAll('.qs-size').forEach((b) => b.classList.remove('active'));
    sizeBtn.classList.add('active');

    buildLengths(); // ✅
    updateVariant();
  }

  const lengthBtn = e.target.closest('.qs-length:not(.is-disabled)');
  if (lengthBtn) {
    document.querySelectorAll('.qs-length').forEach((b) => b.classList.remove('active'));
    lengthBtn.classList.add('active');

    updateVariant();
  }
});

/* AJAX ADD TO CART (cart drawer support) */
document.querySelector('.qs-add').addEventListener('click', async function (e) {
  e.preventDefault();

  const variantId = qsVariantId.value;

  if (!variantId) return;

  try {
    //this.classList.add('loading');
    this.disabled = true;
    this.textContent = 'Adding to cart';
    await window.CartUtils.addItemToCart(variantId, 1);
    closeQuickShop();
    await window.CartUtils.refreshCartDrawer();
  } catch (err) {
    console.error(err);
  } finally {
    //this.classList.remove('loading');
    this.disabled = false;
    this.textContent = 'Add to cart';
  }
});
